module.exports = "/assets/f2af0705130d0adb5425841b264fb220.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OH.png
// module id = 1680
// module chunks = 0